export default "__VITE_ASSET__de373c24__"